import React, { useEffect } from 'react';

import { PageHeader, IframeView } from '../../components';
import { META_TITLE } from '../../utils/constants';
import { buildIframeUrl } from '../../utils/iframe';
import * as S from './AdminHome.styles';

export default function AdminHome() {
	useEffect(() => {
		// Set document title
		document.title = `Staff Dashboard | ${META_TITLE}`;
	}, []);

	return (
		<S.Wrapper>
			<PageHeader>Dashboard</PageHeader>
			<IframeView src={buildIframeUrl('spDashboard')} title="Dashboard" />
		</S.Wrapper>
	);
}
